<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="w-full h-full p-1">
  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
      <form [formGroup]="wellTypeForm" class="p-3">
        <!-- Validation errors from backend -->
        @if (validationErrors().length > 0) {
        <div class="flex flex-col gap-2 mb-3">
          @for (error of validationErrors(); track $index) {
          <p-message severity="error" [text]="error" styleClass="w-full" />
          }
        </div>
        }

        <div class="flex flex-col space-y-2">

          <p-select class="w-full" formControlName="type" [options]="wellTypes"></p-select>

          <p-fieldset legend="Elevation">
            <div class="flex flex-col space-y-2">
              <div class="flex flex-col">
                <label for="drillFloorElevation">Drill Floor Elevation {{ depthRelativeTo }}</label>
                <div class="flex items-start gap-2">
                  <app-validated-number-input
                    class="flex-1 min-w-0"
                    [control]="control('drillFloorElevation')"
                    [value]="control('drillFloorElevation').value"
                    [validation]="{ required: true, min: 0, max: depthValidation.max }"
                    [unit]="lengthUnit"
                  ></app-validated-number-input>
                  <p-button size="small" icon="pi pi-pencil" class="outlined-button" outlined="true"
                    (click)="editField('drillFloorElevation')" title="Edit Drill Floor Elevation"></p-button>
                </div>
                @if (control('drillFloorElevation').invalid) {
                  <p class="validation-error">{{ dfeError }}</p>
                }
              </div>

              @if (control('type').value !== 'Subsea') {
              <div class="flex flex-col">
                <label for="wellheadElevation">
                  {{ wellheadType }} {{ wellheadElevationRelativeTo }}
                </label>
                   <app-validated-number-input
                    class="w-full"
                    [control]="control('wellheadElevation')"
                    [value]="control('wellheadElevation').value"
                    [validation]="{ required: true, min: 0, max: depthValidation.max }"
                    [unit]="lengthUnit"
                  ></app-validated-number-input>
                <!-- <p-button size="small" icon="pi pi-pencil" class="outlined-button" outlined="true" (click)="editField('wellheadDepth')" title="Edit Wellhead Depth"></p-button> -->
              </div>
              }

              @if (control('type').value === 'Subsea') {
              <div class="flex flex-col">
                <label for="wellheadDepth">
                  {{ wellheadType }} {{ wellheadElevationRelativeTo }}
                </label>
                <div class="flex items-start gap-2">
                  <app-validated-number-input
                    class="flex-1 min-w-0"
                    [control]="control('wellheadDepth')"
                    [value]="control('wellheadDepth').value"
                    [validation]="{ required: true, min: 0, max: depthValidation.max }"
                    [unit]="lengthUnit"
                  ></app-validated-number-input>
                  <!-- <p-button size="small" icon="pi pi-pencil" class="outlined-button" outlined="true" (click)="editField('wellheadDepth')" title="Edit Wellhead Depth"></p-button> -->
                </div>
              </div>
              }
            </div>
          </p-fieldset>

          @if (waterDepthVisible) {
          <p-fieldset legend="Offshore">
            <div class="flex flex-col space-y-2">
              <div class="flex flex-col">
                <label for="waterDepth">Water Depth ({{ lengthUnit }})</label>
                <div class="flex items-start gap-2">
                  <app-validated-number-input
                    class="flex-1 min-w-0"
                    [control]="control('waterDepth')"
                    [value]="control('waterDepth').value"
                    [validation]="{ required: true, min: 1, max: depthValidation.max }"
                    [unit]="lengthUnit"
                  ></app-validated-number-input>
                  <p-button size="small" icon="pi pi-pencil" class="outlined-button" outlined="true"
                    (click)="editField('waterDepth')" title="Edit Water Depth"></p-button>
                </div>
                @if (control('waterDepth').invalid) {
                  <p class="validation-error">Wellhead must be above the seafloor</p>
                }
              </div>
              <label>Mudline: {{ mudlineDepth }} ({{ lengthUnit }})</label>
            </div>
          </p-fieldset>
          }
        </div>
      </form>
    </p-scrollPanel>
  </app-tool-loader>
</div>